"use client";
import {
  HeadingContext
} from "./XPF5GU3Q.js";
import {
  createComponent,
  createElement,
  createHook
} from "./3ORBWXWF.js";
import {
  useMergeRefs,
  useTagName
} from "./6O5OEQGF.js";
import {
  __spreadProps,
  __spreadValues
} from "./4R3V3JGP.js";

// src/heading/heading.tsx
import { useContext, useMemo, useRef } from "react";
import { jsx } from "react/jsx-runtime";
var useHeading = createHook((props) => {
  const ref = useRef(null);
  const level = useContext(HeadingContext) || 1;
  const Element = `h${level}`;
  const tagName = useTagName(ref, Element);
  const isNativeHeading = useMemo(
    () => !!tagName && /^h\d$/.test(tagName),
    [tagName]
  );
  props = __spreadProps(__spreadValues({
    render: /* @__PURE__ */ jsx(Element, {}),
    role: !isNativeHeading ? "heading" : void 0,
    "aria-level": !isNativeHeading ? level : void 0
  }, props), {
    ref: useMergeRefs(ref, props.ref)
  });
  return props;
});
var Heading = createComponent((props) => {
  const htmlProps = useHeading(props);
  return createElement("h1", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  Heading.displayName = "Heading";
}

export {
  useHeading,
  Heading
};
